var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 挫折忍耐度 "),
            _c("span", { staticClass: "en-text" }, [
              _vm._v("Frustration tolerance"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c(
              "el-select",
              {
                staticClass: "w-100",
                attrs: { placeholder: "請選擇" },
                model: {
                  value: _vm.activity.FrustrationTolerance,
                  callback: function ($$v) {
                    _vm.$set(_vm.activity, "FrustrationTolerance", $$v)
                  },
                  expression: "activity.FrustrationTolerance",
                },
              },
              [
                _c("el-option", { attrs: { label: "高 (High)", value: 0 } }),
                _c("el-option", { attrs: { label: "中 (Medium)", value: 1 } }),
                _c("el-option", { attrs: { label: "低 (Low)", value: 2 } }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 具體事蹟 "),
            _c("span", { staticClass: "en-text" }, [
              _vm._v("Specific records"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.activity.ExtracurricularActivities,
                callback: function ($$v) {
                  _vm.$set(_vm.activity, "ExtracurricularActivities", $$v)
                },
                expression: "activity.ExtracurricularActivities",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 社團/興趣 "),
            _c("span", { staticClass: "en-text" }, [
              _vm._v("Community/hobbies"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.activity.Interest,
                callback: function ($$v) {
                  _vm.$set(_vm.activity, "Interest", $$v)
                },
                expression: "activity.Interest",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 優良事蹟 "),
            _c("span", { staticClass: "en-text" }, [
              _vm._v("Excellence records"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.activity.OutstandingPerformance,
                callback: function ($$v) {
                  _vm.$set(_vm.activity, "OutstandingPerformance", $$v)
                },
                expression: "activity.OutstandingPerformance",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "edit-btn-wrap" }, [
        _c(
          "button",
          {
            staticClass: "put-btn",
            attrs: { type: "button" },
            on: { click: _vm.saveActivity },
          },
          [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }